export default __webpack_public_path__ + "static/ada_health_history-140b37dc1ac4d9865156229ffd48aa94.pdf";